import type { MouseEventHandler } from 'react';
import type { ButtonProps } from '../Button';

// export type BannerOrientation = 'vertical' | 'horizontal';

export type BannerTheme = 'purple' | 'blue';

export interface BannerData {
  title: string;
  text?: string;
  theme?: BannerTheme;
  backgroundImage: string;
  image?: string;

  btnText?: string;
  onClick?: MouseEventHandler;
  noArrow?: boolean;
  center?: boolean;
}

export interface BannerProps
  extends BannerData,
    Pick<ButtonProps, 'iconLeft' | 'iconRight' | 'breakSpaces'> {}
